<template>
<div class="chapter">
<div class="inner_page">
<h2 class="prect"><a id="pV"></a>Contents</h2>
<p class="contents-1"><a href="#/acknowledgements.htm"><i>Acknowledgements</i></a></p>
<p class="contents-1"><a href="#/list_of_abbreviations.htm"><i>List of Abbreviations</i></a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/introduction_facing_multiple_challenges.htm">Introduction: Facing Multiple Challenges</a></p>
<p class="contents"><a href="#/1_the_making_of_todays_china.htm">1 The Making of Today’s China</a></p>
<p class="contents"><a href="#/2_the_broken_economic_model.htm">2 The Broken Economic Model</a></p>
<p class="contents"><a href="#/3_the_elusive_knowledge_economy.htm">3 The Elusive Knowledge Economy</a></p>
<p class="contents"><a href="#/4_finance.htm">4 Finance</a></p>
<p class="contents"><a href="#/5_social_welfare_missing_umbrella.htm">5 Social Welfare: Missing Umbrella</a></p>
<p class="contents"><a href="#/6_the_environment.htm">6 The Environment</a></p>
<p class="contents"><a href="#/7_threats_to_social_stability.htm">7 Threats to Social Stability</a></p>
<p class="contents"><a href="#/8_threats_to_civil_stability.htm">8 Threats to Civil Stability</a></p>
<p class="contents"><a href="#/9_identity_future_of_state_and_party.htm">9 Identity: Future of State and Party</a></p>
<p class="contents"><a href="#/10_america_and_china_common_interests_mutual_antagonisms.htm">10 America and China: Common Interests, Mutual Antagonisms</a></p>
<p class="contents"><a href="#/11_great_power_relationships.htm">11 Great Power Relationships</a></p>
<p class="contents"><a href="#/12_central_asia.htm">12 Central Asia</a></p>
<p class="contents"><a href="#/13_undeclared_war_in_the_fourth_dimension.htm">13 Undeclared War in the Fourth Dimension?</a></p>
<p class="contents"><a href="#/14_nervous_neighbours.htm">14 Nervous Neighbours</a></p>
<p class="contents"><a href="#/15_china_in_the_world.htm">15 China in the World</a></p>
<p class="contents"><a href="#/16_outcomes.htm">16 Outcomes</a></p>
<p class="linespace"></p>
<p class="contents-1"><a href="#/notes.htm"><i>Notes</i></a></p>
<p class="contents-1"><a href="#/bibliography.htm"><i>Bibliography</i></a></p>
<p class="contents-1"><a href="#/index.htm"><i>Index</i></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?001871ef